// components/Header.jsx
import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="p-3 border-b fixed w-full top-0 left-0 z-10">
      <div className="container mx-auto flex justify-start items-center">
        {/* Logo Link to Home */}
        <Link to="/">
          <img
            src="/Logo_Black.png"
            alt="Tarn Logo"
            className="h-7" // Adjust height as needed
          />
        </Link>
      </div>
    </header>
  );
}

export default Header;